export default __webpack_public_path__ + "static/media/as-applied-maps.4d525567.svg";